import React, { useEffect, useState } from 'react'

import { Table } from 'react-bootstrap'

import { AccountingSystemDialog } from '../common/AccountingSystemDialog'
import { money } from '../common/helpers'
import { NoRecords } from '../common/NoRecords'
import axiosClient from '../service/axiosClient'
import {
    AccountingSystem,
    accountingSystemExtension,
    defaultAccountingSystem,
} from '../types/AccountingSystem'
import { Package } from '../types/gopay'


type GoPayInvoice = {
    'id': number,
    'invoiceName': string,
    'selectedPackage': Package,
    'status': 'PAID' | 'UNPAID',
    'price': number,
    'parentPaymentCreatedAt': string,
    'parentStatusCreatedAt': string
}

function MyInvoicesList() {
    const [invoices, setInvoices] = useState<GoPayInvoice[]>([])

    // Invoice the accounting-system picker is open for, null when it is closed
    const [exportInvoice, setExportInvoice] = useState<GoPayInvoice | null>(null)
    useEffect(() => {
        axiosClient.get<GoPayInvoice[]>('/gopay/invoice/info').then(response => {
            setInvoices(response.data)
        }).catch(error => {
            console.log('error', error)
        })

    }, [])

    function downloadInvoice(invoice: GoPayInvoice) {
        axiosClient.get('/gopay/invoice/generate/' + invoice.id).then(response => {
            axiosClient({
                url: '/gopay/invoice/download/' + invoice.invoiceName,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                const href = URL.createObjectURL(response.data)

                const link = document.createElement('a')
                link.href = href
                link.setAttribute('download', 'faktura_' + invoice.invoiceName + '.pdf')
                document.body.appendChild(link)
                link.click()

                document.body.removeChild(link)
                URL.revokeObjectURL(href)
            })
        })
    }

    function downloadInvoiceXml(invoice: GoPayInvoice,
                                system: AccountingSystem = defaultAccountingSystem) {
        axiosClient.get('/gopay/invoice-export/xml/' + invoice.id, {params: {system}}).then(response => {
            axiosClient({
                url: '/gopay/invoice-export/download/' + invoice.invoiceName,
                method: 'GET',
                responseType: 'blob',
                params: {system},
            }).then((response) => {
                const href = URL.createObjectURL(response.data)

                const link = document.createElement('a')
                link.href = href
                link.setAttribute('download',
                    'faktura_' + invoice.invoiceName + '.' + accountingSystemExtension(system))
                document.body.appendChild(link)
                link.click()

                document.body.removeChild(link)
                URL.revokeObjectURL(href)
            })
        })
    }

    return (
        <><Table className={'fndt_table'} responsive>
            <thead>
            <tr>
                <th scope="col">Číslo FA</th>
                <th scope="col">Balík</th>
                <th scope="col">Stav</th>
                <th scope="col">Suma</th>
                <th scope="col" className={'text-end'}>Akcia</th>
            </tr>
            </thead>
            <tbody>
            {invoices.length ?
                invoices.map((invoice, index) => (
                    <tr
                        className=""
                        key={invoice.id}
                        onClick={() => {
                            // navigate('/clients/' + client.id)
                        }}
                    >
                        {/*<td>{client.id}</td>*/}
                        <td>
                            {invoice.invoiceName}
                        </td>
                        <td>
                            {invoice.selectedPackage}
                        </td>
                        <td>
                            {invoice.status === 'PAID' ? 'Zaplatená' : 'Nezaplatená'}
                        </td>
                        <td>
                            {money.format(invoice.price/100)}
                        </td>
                        <td className="text-right">
                            <div className="d-flex gap-2 justify-content-end">
                                <a href={'#'} className={'table-action-link'} onClick={(e) => {
                                    e.preventDefault()
                                    downloadInvoice(invoice)
                                }} title={'Stiahnúť PDF'}>
                                    <i className="bi bi-download primary-text-color"></i>
                                </a>
                                <a href={'#'} className={'table-action-link'} onClick={(e) => {
                                    e.preventDefault()
                                    setExportInvoice(invoice)
                                }} title={'Stiahnúť XML'}>
                                    <i className="bi bi-filetype-xml primary-text-color"></i>
                                </a>
                            </div>
                        </td>
                    </tr>
                )) : <tr>
                    <td colSpan={5}><NoRecords/></td>
                </tr>}
            </tbody>
        </Table>
        <AccountingSystemDialog show={!!exportInvoice}
                                onClose={() => setExportInvoice(null)}
                                onConfirm={(system: AccountingSystem) => {
                                    if (exportInvoice) {
                                        downloadInvoiceXml(exportInvoice, system)
                                    }
                                }}/>
        </>

    )
}

export default MyInvoicesList
